import PropTypes from 'prop-types'
import React, { useContext, useMemo } from 'react'

import SliderMobile from 'components/SliderMobile'
import { ResizeContext } from 'contexts/Resize'
import { Col, Row } from 'styles/components/layout'

import BNutritionFeature from './components/BNutritionFeature'

const IconsWithDescription = ({ data }) => {
  const { mobile } = useContext(ResizeContext)

  return useMemo(
    () =>
      mobile ? (
        <SliderMobile isWhite={true} amount={data.list.length}>
          {data.list.map(item => (
            <div key={item.icon}>
              <BNutritionFeature item={item} />
            </div>
          ))}
        </SliderMobile>
      ) : (
        <Row>
          {data.list.map(item => (
            <Col
              key={item.icon}
              width={{
                xs: 1,
                md: 4 / 12,
                lg: 4 / 12,
              }}
            >
              <BNutritionFeature item={item} />
            </Col>
          ))}
        </Row>
      ),
    [mobile, data.list],
  )
}

IconsWithDescription.propTypes = {
  data: PropTypes.object.isRequired,
}

export default IconsWithDescription
